import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import fencingExample1 from '../_content/IMG_3320.webp'
import fencingExample2 from '../_content/fencing1.webp'
import fencingExample3 from '../_content/fencing3.webp'
import fencingExample4 from '../_content/fencing4.webp'
import fencingExample5 from '../_content/gate.webp'
import fencingExample6 from '../_content/fencing6.webp'
import fencingExample7 from '../_content/fencing7.webp'
import fencingExample8 from '../_content/fencing8.webp'
import fencingExample9 from '../_content/fencing9.webp'
import fencingExample10 from '../_content/fencing10.webp'
import fencingExample11 from '../_content/fencing11.webp'
import fencingExample12 from '../_content/fencing12.webp'
import fencingExample13 from '../_content/fencing13.webp'
import fencingExample14 from '../_content/fencing14.webp'

const FencingServices = () => {
  return (
    <>
      <ServicesHeader
        background={fencingExample2}
        text="Fencing & Gate Services"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          High-quality fencing and gates designed to improve security, privacy and kerb appeal all across Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Durable fencing built for strength and style
            </Typography>

            <Typography className="section-subtext">
              Whether you're securing your garden, adding privacy or upgrading your outdoor space, we install fencing and gates that are built to last and finished to a high standard.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Precision Installation',
                  text: 'Every fence and gate is installed with care, ensuring strong foundations, straight lines and a professional finish.',
                },
                {
                  title: 'Tailored Solutions',
                  text: 'We offer a wide range of styles and materials, helping you choose the perfect option for your property and needs.',
                },
                {
                  title: 'Reliable Service',
                  text: 'We manage the entire process from start to finish, delivering on time with clear communication throughout.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[fencingExample13, fencingExample2, fencingExample12, fencingExample11, fencingExample9, fencingExample10, fencingExample8, fencingExample14, fencingExample1, fencingExample3, fencingExample4, fencingExample7, fencingExample6, fencingExample5].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Fencing example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default FencingServices